import { render, staticRenderFns } from "./SubscribersForm.vue?vue&type=template&id=2986777d&scoped=true"
import script from "./SubscribersForm.vue?vue&type=script&lang=ts"
export * from "./SubscribersForm.vue?vue&type=script&lang=ts"
import style0 from "./SubscribersForm.vue?vue&type=style&index=0&id=2986777d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2986777d",
  null
  
)

export default component.exports